import { LoadScriptProps } from "@react-google-maps/api";

export const GOOGLE_MAPS_LIBRARIES_TO_USE: LoadScriptProps["libraries"] = [
  "places",
];
